/** Set on `[data-scroll-container]` by `DashboardTopBar` (measured height). */
export const DASHBOARD_TOPBAR_STICKY_HEIGHT_VAR = "--dashboard-topbar-sticky-height";

/** Sticky `top` for in-page sidebars that should sit below the greeting header. */
export function dashboardStickyBelowTopBar(gapPx = 20): string {
  return `calc(var(${DASHBOARD_TOPBAR_STICKY_HEIGHT_VAR}, 7.5rem) + ${gapPx}px)`;
}

/** Gap below the dashboard greeting header used by in-page nav sidebars. */
export const DASHBOARD_IN_PAGE_NAV_TOP_GAP_PX = 10;

/** `scroll-margin-top` for anchor targets that should clear the sticky greeting header. */
export function dashboardScrollMarginBelowTopBar(
  gapPx = DASHBOARD_IN_PAGE_NAV_TOP_GAP_PX,
): string {
  return dashboardStickyBelowTopBar(gapPx);
}
